<template>
    <kl-ol-map-tools-action-group mod-vertical>
        <kl-ol-map-tools-action
            @click="onShowGpsLocation"
            v-vl-tooltip.left.hide-immediately="'Toon&nbsp;mijn&nbsp;locatie'"
            :icon="iconId">
        </kl-ol-map-tools-action>
    </kl-ol-map-tools-action-group>
</template>

<script lang="ts">
import {defineComponent, ref} from 'vue';
import proj4 from "proj4";

export default defineComponent({
    name: 'KlDrawZoneGeoLocation',
    emits: ['zoom-to-extent'],
    props: {
        projection: { type: String, required: true },
        extentBound: { type: Number, default: 50 },
    },
    setup(props, {emit}) {

        const _defaultIconId = 'location-gps';
        const _errorIconId = 'question-mark-naked';

        const iconId = ref<string>(_defaultIconId);

        const _onOk = (result: GeolocationPosition) => {
            try {
                const projectedCoordinates = proj4('EPSG:4326', props.projection, [result.coords.longitude, result.coords.latitude]);

                const extent = [
                    projectedCoordinates[0] - props.extentBound,
                    projectedCoordinates[1] - props.extentBound,
                    projectedCoordinates[0] + props.extentBound,
                    projectedCoordinates[1] + props.extentBound
                ];

                emit('zoom-to-extent', extent);
            }
            catch (e) {
                _onError();
            }
        }

        const _onError = () => {
            iconId.value = _errorIconId;
        }

        const onShowGpsLocation = () => {
            iconId.value = _defaultIconId;

            // check presence of geolocation api
            if (!navigator?.geolocation) {
                _onError();
                return;
            }

            navigator.geolocation.getCurrentPosition(_onOk, _onError);
        }

        return {
            onShowGpsLocation,
            iconId,
        }
    }
})
</script>

<style scoped lang="scss">
</style>
